var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ticketNote" } }, [
    _c("div", { staticClass: "vo-card" }, [
      _c("div", { staticClass: "header-small" }, [_vm._v("Manager Tools")]),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("Ticket Status")
            ]),
            _vm._v(" "),
            _c(
              "v-radio-group",
              {
                attrs: {
                  disabled: _vm.statusLockout,
                  loading: _vm.statusLockout,
                  "hide-details": "",
                  mandatory: true
                },
                on: { change: _vm.statusChanged },
                model: {
                  value: _vm.ticket.status,
                  callback: function($$v) {
                    _vm.$set(_vm.ticket, "status", $$v)
                  },
                  expression: "ticket.status"
                }
              },
              _vm._l(_vm.$store.getters.company.statuses, function(
                status,
                key
              ) {
                return _c(
                  "v-radio",
                  { key: key, attrs: { color: "primary", value: key } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-transform": "capitalize" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(key))]
                    )
                  ]
                )
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "section-title" }, [_vm._v("Assignees")]),
            _vm._v(" "),
            _c("v-select", {
              ref: "assigneePicker",
              attrs: {
                placeholder: "Add Assignees",
                disabled: _vm.assigneePicker.lockout,
                autocomplete: "",
                loading: _vm.assigneePicker.loading,
                multiple: "",
                chips: "",
                items: _vm.assigneePicker.searchResults,
                "item-text": "fullName",
                "search-input": _vm.assigneePicker.searchText,
                "item-value": "_id"
              },
              on: {
                keyup: function($event) {
                  _vm.searchAssignees(_vm.assigneePicker.searchText)
                },
                change: function($event) {
                  _vm.changeAssignee($event)
                },
                "update:searchInput": function($event) {
                  _vm.$set(_vm.assigneePicker, "searchText", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "selection",
                  fn: function(data) {
                    return [
                      _c(
                        "div",
                        { staticClass: "vo-user-chip" },
                        [
                          _c("vo-avatar", {
                            staticClass: "avatar",
                            attrs: { user: data.item, size: 24 }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(data.item.fullName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { fab: "", flat: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.removeAssignee(data.item, $event)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.ticket.assignees,
                callback: function($$v) {
                  _vm.$set(_vm.ticket, "assignees", $$v)
                },
                expression: "ticket.assignees"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("Ticket Tags")
            ]),
            _vm._v(" "),
            _c("v-select", {
              ref: "ticketTagPicker",
              attrs: {
                items: _vm.ticketTags,
                chips: "",
                multiple: "",
                "item-value": "_id",
                "item-text": "title"
              },
              on: {
                change: function($event) {
                  _vm.changeTicketTag($event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "selection",
                  fn: function(data) {
                    return [
                      _c(
                        "div",
                        { staticClass: "vo-tag" },
                        [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(data.item.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "tag-btn",
                              attrs: { fab: "", flat: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.removeTicketTag(data.item._id, $event)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.ticket.type,
                callback: function($$v) {
                  _vm.$set(_vm.ticket, "type", $$v)
                },
                expression: "ticket.type"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da1ae86c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da1ae86c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketManageTools.vue
// module id = 605
// module chunks = 4